"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
        md: { span: 24 },
        lg: { span: 14 },
        xxl: { span: 10 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
        md: { span: 24 },
        lg: { span: 10 },
        xxl: { span: 14 },
    },
};
exports.formItemLayout = formItemLayout;
var formItemVerticalLayout = {
    labelCol: {
        span: 24,
    },
    wrapperCol: {
        span: 24,
    },
};
exports.formItemVerticalLayout = formItemVerticalLayout;
var fullWidthInput = {
    wrapperCol: {
        span: 24,
    },
};
exports.fullWidthInput = fullWidthInput;
var formItemLayoutWithOutLabel = {
    wrapperCol: {
        xs: { span: 24, offset: 0 },
        sm: { span: 16, offset: 8 },
        md: { span: 24, offset: 0 },
        lg: { span: 10, offset: 14 },
        xxl: { span: 14, offset: 10 },
    },
};
exports.formItemLayoutWithOutLabel = formItemLayoutWithOutLabel;
